import React from 'react';
import { I18nextProvider, useTranslation } from 'react-i18next';
import i18n from 'i18next';
import PropTypes from 'prop-types';

export function ThroneTrad({ translation, ...rest }) {
    const { t } = useTranslation();
    let interpolation = rest['interpolation'];
    for (let prop in rest) {
        if (prop !== 'interpolation') {
            interpolation = { ...interpolation, ...rest[prop] };
        }
    }

    return (
        <I18nextProvider i18n={i18n}>
            {t(translation, interpolation)}
        </I18nextProvider>
    );
}

ThroneTrad.defaultProps = {
    interpolation: {},
};

ThroneTrad.propTypes = {
    translation: PropTypes.string.isRequired,
    interpolation: PropTypes.object,
};
